var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import messages from '@/modules/tasks/taskMessages';
import { useGetTaskTemplates } from '@/shared/hooks/task/useGetTaskTemplates';
import guid from '@/shared/utils/guid';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { listItemMsg } from '../../FormattedListValue';
import AutoComplete from '../select/AutoComplete';
export var TaskTemplateSelect = function (_a) {
    var initialValue = _a.initialValue, placeholder = _a.placeholder, onChange = _a.onChange, _b = _a.includeWithoutTemplate, includeWithoutTemplate = _b === void 0 ? true : _b, _c = _a.useTemplateInCallback, useTemplateInCallback = _c === void 0 ? false : _c;
    var formatMessage = useIntl().formatMessage;
    var data = useGetTaskTemplates().data;
    var taskTemplates = useMemo(function () {
        return data === null || data === void 0 ? void 0 : data.map(function (item) { return ({
            key: item.id,
            label: formatMessage(listItemMsg('taskTemplate', item.id, item.name)),
            resourceId: item.resourceId,
        }); }).sort(function (a, b) { return a.label.toLowerCase().localeCompare(b.label.toLowerCase()); });
    }, [data, formatMessage]);
    var items = useMemo(function () {
        if (!taskTemplates)
            return undefined;
        return includeWithoutTemplate
            ? __spreadArray([{ key: guid.empty, label: formatMessage(messages.TasksWithoutTemplate) }], taskTemplates, true) : taskTemplates;
    }, [formatMessage, taskTemplates, includeWithoutTemplate]);
    var initialSelectedItem = useMemo(function () { var _a; return (_a = (initialValue && (items === null || items === void 0 ? void 0 : items.find(function (item) { return (item === null || item === void 0 ? void 0 : item.key) === initialValue; })))) !== null && _a !== void 0 ? _a : undefined; }, [initialValue, items]);
    return (_jsx(AutoComplete, { items: items, initialSelectedItem: initialSelectedItem, placeholder: placeholder, mode: "edit", onChange: function (item) { return onChange(useTemplateInCallback ? item : item === null || item === void 0 ? void 0 : item.key); } }));
};
export var FilterTaskTemplateSelect = function (_a) {
    var item = _a.item, clearItems = _a.clearItems, setFilter = _a.setFilter, activeFilters = _a.activeFilters, label = _a.label, isAlwaysVisible = _a.isAlwaysVisible, enabled = _a.enabled;
    return ({
        filterItem: item,
        enabled: enabled,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: (_jsx(TaskTemplateSelect, { onChange: function (value) {
                var _a, _b;
                return setFilter((clearItems && !value
                    ? __assign((_a = {}, _a[item] = undefined, _a), clearItems.reduce(function (prev, clearItem) {
                        var _a;
                        return (__assign(__assign({}, prev), (_a = {}, _a[clearItem] = undefined, _a)));
                    }, {})) : (_b = {}, _b[item] = value !== null && value !== void 0 ? value : undefined, _b)));
            }, initialValue: activeFilters[item], placeholder: label })),
    });
};
